import React, {useEffect, useState} from "react";
import {Button, Col, Row, Select} from "antd";
import SelectField from "components/SelectField";
import {useTranslation} from "react-i18next";
import noSelected from "assets/images/noSelectedTransfer.svg";
import './index.scss'
import LimitsModal from "components/LimitsModal/LimitsModal";
import GppModal from "pages/Transfer/components/GPP/component/GppModal";
import GppTransfer from "pages/Transfer/components/GPP/component/GppTransfer";
import CustomTooltip from "components/Tooltip";
import {TabsInfoIco} from "../../../../../modules/CustomIcons";
import {useLocation} from "react-router-dom";
const GPP: React.FC<any> = (props:any) => {
    const {t} = useTranslation()
    const [visible,setVisible] = useState(props.visible)
    const [comeMenu,setComeMenu] = useState(props.comeMenu !== undefined && props.comeMenu !== null ? props.comeMenu : false)
    const [tabIndex,setTabIndex] = useState('')
    const [transferData,setTransferData] = useState()
    const [fields,setFields] = useState([])
    const [selectedType,setSelected] = useState()
    const [category,setCategory] = useState()
    const location = useLocation()

    const pulldata=(data,transferdata,category)=>{
        setFields(transferdata?.fields)
        setTabIndex(data)
        setCategory(category)
        setTransferData(transferdata)
        props.handleVisible(false)
    }

    useEffect(() => {
            setVisible(props.visible)
            console.log("ishledi33")
    }, [props.visible]);




    return (
            <div style={{minHeight:'750px'}}>
                    <Row  className='transfer_child_tabs gpp' >
                        { tabIndex === '' && <Col className={'flex justify_between align_center '} span={24} style={{minWidth: "750px"}}>

                               {/* <Col span={6} style={{marginLeft:30,marginTop:20 }}>*/}
                               {/*    <SelectField*/}
                               {/*    disabled={true}*/}
                               {/*    placeholder={t("transfers.allchosenorg")}*/}
                               {/*    />*/}
                               {/*</Col>*/}
                                <Col span={12} className={'flex justify_end align_center ant-form-item '} style={{marginTop:30}}>
                                    {/*<CustomTooltip className={'gppTooltip'} title={t("transfers.gppInfo")}>*/}
                                    {/*    <Button type={"ghost"} className={'trasparent info_icon'} icon={<TabsInfoIco />} />*/}
                                    {/*</CustomTooltip>*/}
                                    {/*<Button*/}
                                    {/*    type={'primary'}*/}
                                    {/*    ghost*/}
                                    {/*    style={{margin:10,width:"auto"}}*/}
                                    {/*    onClick={()=>setVisible(true)}*/}
                                    {/*>*/}
                                    {/*    {t("transfers.directPayment")}*/}
                                    {/*</Button>*/}
                                    {/*<Button*/}
                                    {/*    disabled={true}*/}
                                    {/*    type={"primary"}*/}
                                    {/*    style={{margin:10,width:"auto",color:'#fff'}}*/}
                                    {/*>*/}
                                    {/*    {t('transfers.createpaymenttemplate')}*/}
                                    {/*</Button>*/}
                                    {/*<Button*/}
                                    {/*    disabled={true}*/}
                                    {/*    type={"primary"}*/}
                                    {/*    style={{margin:10,width:"auto",color:'#fff'}}*/}
                                    {/*>*/}
                                    {/*    {t("home.deleteTemplate")}*/}
                                    {/*</Button>*/}
                                </Col>


                            </Col>
                        }
                        {
                            tabIndex !== '' &&
                            <GppTransfer
                            type={selectedType}
                            selectedValue={(e,bool) => {
                                setTabIndex(e);
                                // setVisible(true)
                            }}
                            fields={fields}
                            category={category}
                            selectedTransfer={transferData}

                            />
                        }
                    </Row>

                {tabIndex === '' && <Row className={'gpp '} style={{ marginTop: "130px" }}>
                        <Col className={'gpp_noData'}>
                            {/*<p className={'noData_text'}>{t('transfers.createTransferTemplate')}</p>*/}
                            <img src={noSelected}/>
                        </Col>

                    </Row>
                }
               <GppModal
                    selectedTransfer={setSelected}
                    selectedValue={pulldata}
                    visible={visible}
                    modalTitle={t('newTransfer.organizations')}
                    onCancel={()=>props.handleVisible(false)}

                />

            </div>
        )
}

export default GPP